import { IconLineCheck, IconLineClose } from "@kalodata/kds-design-icons";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface AccountStatusBadgeProps {
  expired?: boolean;
}

export const AccountStatusBadge = ({ expired = false }: AccountStatusBadgeProps) => {
  return (
    <div
      className={twMerge(
        "inline-flex h-[24px] items-center justify-center gap-[4px] rounded-full border px-[8px] py-[4px]",
        expired ? "border-kds-danger-border bg-kds-danger-soft" : "border-kds-accent-border bg-kds-accent-soft",
      )}
    >
      <span
        className={twMerge(
          "whitespace-nowrap text-[14px] font-medium leading-[16px]",
          expired ? "text-kds-danger-fg" : "text-kds-accent-fg",
        )}
      >
        <Trans>{expired ? "Expired" : "Connected"}</Trans>
      </span>
      {expired ? (
        <IconLineClose size={16} className="text-kds-danger-fg" />
      ) : (
        <IconLineCheck size={16} className="text-kds-accent-fg" />
      )}
    </div>
  );
};
